import React from 'react';
import { withStyles } from '@material-ui/core';
import USezpayLogo from "../../USezpay.svg";

const styles = theme => ({
    root: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        [theme.breakpoints.down('xs')]: {
            justifyContent: "unset",
            marginTop: 20
        },
    },
    signInContainer: {
        height: "max-content",
        [theme.breakpoints.down('xs')]: {
            width: 280,
        },
        [theme.breakpoints.up('sm')]: {
            width: 300,
        }
    },
    domain: { fontSize: "45px", fontWeight: "500" },
    logo: {
        width: 260,
        marginTop: 10,
        marginBottom: 74.6,
        [theme.breakpoints.down('xs')]: {
            display: "none"
        }
    },
    logoMobile: {
        width: 160,
        marginTop: 10,
        [theme.breakpoints.up('sm')]: {
            display: "none"
        },
    },
    textInputs: {
        marginBottom: 65,
        width: "100%"
    },
    title: {
        fontSize: 24,
        color: "rgba(0,0,0,0.5)",
        marginBottom: 50,
        marginTop: 0
    }
})

export const USezpayAuthForm = withStyles(styles)(({title, children, classes}) => {
    return (
        <div className={classes.root}>
            <div className={classes.signInContainer}>
                <div className={classes.domain}>
                    <img className={classes.logo} src={USezpayLogo} alt={"USezpay"}/>
                    <img className={classes.logoMobile} src={USezpayLogo} alt={"USezpay"}/>
                </div>
                <h1 className={classes.title}>{title}</h1>
                {children}
            </div>
        </div>
    )
})
